import { OtherTextField } from '@/pages/onboarding/OtherTextField';
import { QuestionLabel } from '@/pages/onboarding/QuestionLabel';
import type { OnboardingStepProps } from '@/pages/onboarding/onboarding.types';
import { SPECIALTY_OPTIONS, matchOption } from '@/pages/onboarding/onboardingOptions';
import { ChoiceCard, ChoiceCardGroup, Stack } from '@careflux/primitives';
import { Controller, useWatch } from 'react-hook-form';

/** "Sérgrein" chips, shown only for Læknir. */
export const SpecialtyField = ({ copy, control }: OnboardingStepProps) => {
  const specialty = useWatch({ control, name: 'specialty' });

  return (
    <Stack gap="lg">
      <Controller
        name="specialty"
        control={control}
        render={({ field }) => (
          <Stack gap="sm">
            <QuestionLabel id="specialty-label">{copy.profession.specialtyQuestion}</QuestionLabel>
            <ChoiceCardGroup
              aria-labelledby="specialty-label"
              variant="chip"
              value={field.value ?? ''}
              onValueChange={(value) => {
                const next = matchOption(SPECIALTY_OPTIONS, value);
                if (next) field.onChange(next);
              }}
            >
              {SPECIALTY_OPTIONS.map((option) => (
                <ChoiceCard
                  key={option}
                  id={`specialty-${option}`}
                  value={option}
                  label={copy.profession.specialties[option]}
                />
              ))}
            </ChoiceCardGroup>
          </Stack>
        )}
      />
      {specialty === 'other' && (
        <OtherTextField
          name="specialtyOther"
          id="specialty-other-text"
          label={copy.profession.specialtyOtherLabel}
          placeholder={copy.profession.specialtyOtherPlaceholder}
          control={control}
        />
      )}
    </Stack>
  );
};
